import { AfterViewInit, Component, Inject, Input, OnInit } from "@angular/core";
import { Property } from "@app/models/Property";
import { FuturePayment } from "@app/models/FuturePayment";
import { PaymentScheduleSelectorComponent } from "@app/components/paymentSchedule/paymentScheduleSelector.component";
import { PaymentStore } from "@app/services/stores/PaymentStore";
import { UserStore } from "@app/services/stores/UserStore";
import { PropertyApi } from "@app/services/apiServices/PropertyApi";
import { PropertyGroupApi } from "@app/services/apiServices/PropertyGroupApi";
import { SpinnerService } from "@app/services/spinner.service";
import { UtilService } from "@app/services/Util.service";
import { PaymentScheduleApi } from "@app/services/apiServices/PaymentScheduleApi";
import { AmenityApi } from "@app/services/apiServices/AmenityApi";
import { PaymentUiState } from "@app/services/shared/PaymentUiState.enum";
import { PaymentSchedule } from "@app/models/PaymentSchedule";
import { take } from "rxjs/operators";
import { Content } from "@app/models/Content";
import { MatDialog } from "@angular/material/dialog";
import { WalletService } from "@app/services/wallet.service";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { ErrorHandlerService } from "@app/services/ErrorHandler.service";
import { Observable } from "rxjs";
import { StopHoldMigrateDialogComponent } from "@app/pages/properties/landing/stopHoldMigrate.dialog";
import { NoPaymentMethodDialogComponent } from "@app/pages/properties/landing/noPaymentMethod.dialog";
import { DialogErrorDialog } from "@app/components/sharedDialogs/dialogError.dialog";
import { WindowToken } from "@app/util/window.token";
import { Router } from "@angular/router";

@Component({
    selector: 'app-property',
    template: require('./property.directive.html'),
})
export class PropertyComponent implements OnInit, AfterViewInit{
    @Input() property: Property;
    @Input() propertiesSize: number;
    @Input() currentIndex: number;

    viewed = false;
    sortedFuturePayments: FuturePayment[];
    done: boolean;
    doneLoading = false;

    constructor(
        @Inject(WindowToken) private window,
        @Inject(PaymentScheduleSelectorComponent) private paymentScheduleSelectorService: PaymentScheduleSelectorComponent,
        @Inject(PaymentStore) private paymentStore: PaymentStore,
        @Inject(UserStore) private userStore: UserStore,
        @Inject(PropertyApi) private propertyApi: PropertyApi,
        @Inject(PropertyGroupApi) private propertyGroupApi: PropertyGroupApi,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(UtilService) private utilService: UtilService,
        @Inject(PaymentScheduleApi) private paymentScheduleApi: PaymentScheduleApi,
        @Inject(WalletService) private walletService: WalletService,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(AmenityApi) private amenityApi: AmenityApi,
        @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(Router) private router: Router) {

        this.spinnerService.closeSpinner();
    }

    ngOnInit(): void {

        this.doneLoading = false;

        if ((this.property && this.property.id) &&
            (this.propertiesSize === 1 || this.userStore.getSelectedPropertyId() === this.property.id)) {
            this.fillPropertyDetails(this.property);
            this.viewed = true;
        }

    }

    ngAfterViewInit() {
        if (this.propertiesSize > 1) {
            let buttonId = `hiddenPropertyButton-` + this.property.id;
            let element: HTMLElement = document.getElementById(buttonId) as HTMLElement;
            element.click();
        }
    }

    schedulePayment() {
        this.paymentStore.setUiState(PaymentUiState.SCHEDULE_PAYMENT);
    }

    initProperty() {
        if (this.propertiesSize > 1 && this.userStore.getSelectedPropertyId() === this.property.id) {
            this.done = true;
            this.showHide(this.property.id);
        }
    }

    showHide(propertyId: number) {
        if (this.propertiesSize > 1) {
            const coll = document.getElementById("collapsible-" + propertyId);
            coll.classList.toggle("active");
            if (coll.classList.contains('active')) {
                this.userStore.setSelectedPropertyId(propertyId);
            }
            const content = document.getElementById("content-" + propertyId);
            if(this.property.propertyGroupId !== 0 && !content.classList.contains('activeContent')) {
                const group = document.getElementById("content-" + propertyId + "-propertyGroup-" + this.property.propertyGroupId);

                if(!group.classList.contains('activeContent')) {
                    this.showHidePropertyGroup(this.property.propertyGroupId);
                }
            }
            content.classList.toggle('activeContent');
            content.classList.toggle('hiddenContent');
            if (content.classList.contains('activeContent') && !this.viewed) {
                this.fillPropertyDetails(this.property);
                this.viewed = true;
            }
        }
    }

    showHidePropertyGroup(propertyGroupId: number) {
        const coll = document.getElementById("collapsible-propertyGroup-" + propertyGroupId);
        coll.classList.toggle("active");

        let regexp = new RegExp('^content-[0-9]+-propertyGroup-' + propertyGroupId + '$')
        const children = document.body.getElementsByTagName('*');
        for (let i = 0, length = children.length; i < length; i++) {
            const child = children[i];
            if (regexp.test(child.id)) {
                child.classList.toggle('activeContent');
                child.classList.toggle('hiddenContent');
            }
        }
    }

    openModalSelector(paymentSchedule: PaymentSchedule[]) {
        if (paymentSchedule.length === 1) {
            this.router.navigateByUrl('scheduleEdit/' + paymentSchedule[0].id,  { state: {
                scheduleId: paymentSchedule[0].id
            } })
        } else {
            this.paymentScheduleSelectorService.loadPaymentSchedule(paymentSchedule);
        }
    }

    private fillPropertyDetails(property: Property) {
        this.propertyApi.propertiesValidateGet(false, property.hoa.pmc.couponId, property.hoa.couponId, property.couponId)
            .pipe(take(1)).subscribe((resp) => {
                let validationData: any = resp;
                property.isValid = validationData.valid;
                if (validationData.doNotProcess === true) {
                    property.stopHoldCode = validationData.doNotProcessCode;
                    if (validationData.doNotProcessCode === "L01" || validationData.doNotProcessCode === "D01") {
                        property.onHold = true;
                    } else if (validationData.doNotProcessCode === "M01") {
                        property.isMigrate = true;
                    }
                }
            });

        this.propertyApi.propertiesActiveContentGet(false, property.hoa.pmc.couponId, "property", property.hoa.couponId)
            .pipe(take(1)).subscribe((resp) => {
                let contentData: Content[] = resp;
                contentData.forEach(contentDataItem => {
                    contentDataItem.msg = decodeURIComponent(contentDataItem.msg);
                });
                property.propertyContent = contentData;
            }, () => { // error
                property.propertyContent = [];
            });

        let homeownerId = this.userStore.getHoaHomeownerId();
        this.propertyGroupApi.getPropertyGroupCandidates(homeownerId, property.id)
            .pipe(take(1)).subscribe((resp) => {
                property.groupCandidates = resp;
            }, () => { // error
                property.groupCandidates = [];
            });

        this.propertyGroupApi.getAvailableGroups(homeownerId, property.id)
            .pipe(take(1)).subscribe((resp) => {
                property.availableGroups = resp;
            }, () => {
                property.availableGroups = [];
            });

        this.propertyApi.propertiesActiveContentGet(false, property.hoa.pmc.couponId, "pp-sched-pymt", property.hoa.couponId)
            .pipe(take(1)).subscribe((resp) => {
                let contentData: Content[] = resp;
                contentData.forEach(contentDataItem => {
                    contentDataItem.msg = decodeURIComponent(contentDataItem.msg);
                })
                property.scheduleContent = contentData;
            }, () => {
                property.scheduleContent = [];
            });

        // *********************************** //

        if (property.nextPaymentDueDate) {
            property.nextPaymentDueDate.formattedFullDate = this.utilService.dateFormat(property.nextPaymentDueDate.month, property.nextPaymentDueDate.day, property.nextPaymentDueDate.year);
        }

        // Get the payment schedules for this property by propertyId
        this.paymentScheduleApi.propertiesIdPaymentSchedulesGet(property.id)
            .pipe(take(1)).subscribe((resp) => {

                // set data for payment schedule directive display
                property.paymentSchedules = resp;
                if (property.paymentSchedules) {
                    for (let j = 0; j < property.paymentSchedules.length; j++) {
                        // filter out canceled-by-user from futurePayments on each schedule
                        property.paymentSchedules[j].futurePayments= property.paymentSchedules[j].futurePayments
                            ?.filter(fp => fp.status !== 'cancelled-by-user' && fp.status !== 'cancelled-by-CSR');
                        let nextFuturePayment = this.utilService.findNextPayment(property.paymentSchedules[j].futurePayments);
                        property.paymentSchedules[j].nextPaymentDate = nextFuturePayment.date;
                        property.paymentSchedules[j].nextPaymentAmount = nextFuturePayment.total;
                    }
                }

                // reset arrays after each get request
                this.sortedFuturePayments = [];
                const tempSortedFuturePayments: FuturePayment[] = [];

                // iterate through response and populate tempSortedFuturePayments[] with future payments

                for (let i = 0; i < resp.length; i++) {
                    if (resp[i].futurePayments && resp[i].futurePayments.length) {
                        for (let f = 0; f < resp[i].futurePayments.length; f++) {
                            tempSortedFuturePayments.push({
                                id: resp[i].futurePayments[f].id,
                                version: resp[i].futurePayments[f].version,
                                date: resp[i].futurePayments[f].date,
                                total: resp[i].futurePayments[f].total,
                                items: resp[i].futurePayments[f].items,
                                status: resp[i].futurePayments[f].status,
                                correspondingPaymentScheduleId: resp[i].id,
                                correspondingPaymentScheduleNickname: resp[i].nickname
                            });
                        }
                    }
                }

                // sort by tempSortedFuturePayments[] by ascending date since it isn't returned pre-sorted
                tempSortedFuturePayments.sort(function (a, b) {
                    let x: any = new Date(a.date.formattedFullDate);
                    let y: any = new Date(b.date.formattedFullDate);
                    return x - y;
                });
                // create a list of schedule IDs to ignore so that they don't show up twice in sortedFuturePayments[]
                let listOfScheduleIdsToIgnore = [];

                // iterate though tempSortedFuturePayments[] to populate sortedFuturePayments[]
                for (let k = 0; k < tempSortedFuturePayments.length; k++) {
                    const currentCorrespondingPaymentScheduleId = tempSortedFuturePayments[k].correspondingPaymentScheduleId;
                    const paymentStatusNotCancelled = tempSortedFuturePayments[k].status !== "cancelled"
                    if (listOfScheduleIdsToIgnore.indexOf(currentCorrespondingPaymentScheduleId) < 0 && paymentStatusNotCancelled) {
                        this.sortedFuturePayments.push(tempSortedFuturePayments[k]);
                        listOfScheduleIdsToIgnore.push(currentCorrespondingPaymentScheduleId);
                    }
                }

                property.sortedFuturePayments = this.sortedFuturePayments;
                property.allFuturePayments = tempSortedFuturePayments;
            }, (err) => {
                console.error('propertiesIdPaymentSchedulesGet', err);
            });
    }

    isOnHold(property, availableAmenities): boolean {
        if (property.stopHoldCode === 'L01' && availableAmenities.length > 0) {
            return false;
        }
        return !!property.stopHoldCode;
    }

    makePayment() {
        this.getAvailableAmenities(this.property).pipe(take(1)).subscribe((availableAmenities) => {
            if (this.isOnHold(this.property, availableAmenities)) {
                this.dialog.open(StopHoldMigrateDialogComponent, {
                    data: { reasonCode: this.property.stopHoldCode }
                })
            } else if (!this.property.isValid) {
                this.dialog.open(StopHoldMigrateDialogComponent)
            } else {  // make payment as usual
                this.walletService.hasPaymentMethods().pipe(take(1)).subscribe((resp) => {
                    if (resp) {
                        this.router.navigateByUrl('/properties/' + this.property.id + '/payment',
                            { state: { propertyId: this.property.id,
                                property: this.property,
                                availableAmenities: availableAmenities } })
                    } else {
                        const dialogRef = this.dialog.open(NoPaymentMethodDialogComponent)
                        dialogRef.afterClosed().pipe(take(1)).subscribe((value) => {
                            if (value === 'Add') {
                                this.router.navigateByUrl('/wallet',
                                    { state: { comingFromPayNow: true,
                                        propertyId: this.property.id,
                                        property: this.property } })
                            }
                        }, () => {})
                    }
                }, (err) => {
                    this.networkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe((resp) => {
                        if (resp === true) {
                            this.makePayment();
                        }
                    });
                });
            }
        })
    }

    getAvailableAmenities(property: Property) {
        return new Observable(observer => {
            this.amenityApi.activeAmenitiesByCouponGet(false, property.hoa.pmc.couponId, property.hoa.couponId, property.couponId)
                .pipe(take(1)).subscribe((response) => {
                    observer.next(response)
                }, (err) => {
                    let errMsg: string = undefined;
                    if (err.error && err.error.message) {
                        errMsg = err.error.message;
                    }
                    this.errorHandlerService.handleNetworkError(err, true, errMsg).pipe(take(1)).subscribe();
                    observer.error()
                });
        });

    }

    newPropertyGroupId(propertyGroupId: number, index: number) {
        if(index === 0) { // reset for the first
            this.userStore.setPreviousPropertyGroupId(propertyGroupId);
            return true;
        }
        if(this.userStore.getPreviousPropertyGroupId() === propertyGroupId) {
            return false;
        }
        this.userStore.setPreviousPropertyGroupId(propertyGroupId);
        return true;
    }

    addToExistingGroup(existingGroupId: number) {
        if(existingGroupId > 0) {
            this.spinnerService.showSpinner();
            let propertyIds = [this.property.id];
            this.propertyGroupApi.propertyGroupAddProperties(existingGroupId, propertyIds)
                .pipe(take(1)).subscribe(() => {
                    this.spinnerService.closeSpinner();
                    this.router.navigateByUrl('/properties/propertyGroup/' + existingGroupId,
                        { state: { propertyGroupId: existingGroupId } });
                }, (err) => {
                    const dialogRef = this.dialog.open(DialogErrorDialog, {
                        closeOnNavigation: false,
                        disableClose: true,
                    })
                    dialogRef.afterClosed().pipe(take(1)).subscribe((value) => {
                        this.spinnerService.closeSpinner();
                        this.networkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((resp) => {
                                if (resp === true) {
                                    this.addToExistingGroup(existingGroupId);
                                } else {
                                    this.router.navigateByUrl('/properties');
                                }
                            });
                    }, () => {})

                });
        }
    }
}
